var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"height":"677px","width":"912px"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('h2',{staticStyle:{"margin-bottom":"24px"}},[_vm._v("Журнал билетов")]),_c('div',{ref:"scroll",staticClass:"scroll"},[_c('VTable',{ref:"table",attrs:{"itemsType":"array","columns":_vm.headers,"items":_vm.tickets,"isHistory":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }